// CONSTANTS are all caps.
const NS = 'Weather';
const CLS = 'weather';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/weather.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

export class Weather {
	constructor($el) {
		// $el is the widget node return by the loadWeather function
		this.$el = $el;
		this.api = $(this.$el).data('api');
		this.lat = $(this.$el).data('lat');
		this.lon = $(this.$el).data('lon');
	}

	init() {
		this.setWeather().then((response) => {
			console.log(response);
			return Promise.resolve(response.json());
		}).then((response) => {
			console.log(response);

			if (response &&
				response.weather.length > 0) {
				this.renderResults(response);
			} else {
				this.renderResults([]);
				console.log('return response is null');
			}
		});
	}

	formatDay(index) {
		let arr = [
			'Monday',
			'Tuesday',
			'Wednesday',
			'Thursday',
			'Friday',
			'Saturday',
			'Sunday',
		];

		return arr[index - 1];
	}

	formatMonth(index) {
		let arr = [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December',
		];

		return arr[index];
	}

	renderResults(data) {
		let weather = data.weather[0].main;
		let place = data.name;
		let temp = data.main.temp;
		let imgCode = data.weather[0].icon;
		let imgUrlPrefix = 'http://openweathermap.org/img/w/';
		let today = new Date();
		let day = this.formatDay(today.getDay());
		let month = this.formatMonth(today.getMonth());

		let htmlTemplate = `
			<div class="weather-wrapper">
				<img class="weather-icon" src="${imgUrlPrefix + imgCode}.png" />
				<span class="weather-des">${(temp-273.15).toFixed(0)}° &amp; ${weather} on ${day} ${today.getDate()} ${month} in ${place}</span>
			</div>
		`;

		$('.weather').html(htmlTemplate);
	}

	setWeather() {
		// Add Some logic here
		let apiUrl = this.api + '/' + this.lat + '/' + this.lon;
		console.log(apiUrl);

		return fetch(apiUrl);
		// return Api.getApi(apiUrl)
	}
	// Add more functions like on above here
}
